module.exports = __webpack_public_path__ + "media/images/icons/clipboard-c230ce2f045906c0d13b9412865b22e8.svg";